import { goalSkillEnums } from './constants';

export const SkillCard = ({ type }) => {
    return (
        <div>
            {type === goalSkillEnums.SKILL && <div className="goal-skill-box">Skill</div>}

            {type === goalSkillEnums.PARENT_TRAINING && <div className="goal-parent-training-box">Parent Training</div>}

            {type === goalSkillEnums.BEHAVIOR && <div className="goal-behavior-box">Behavior</div>}
        </div>
    );
};
